<template>
  <v-card :loading="loading">
    <v-card-title>
      <slot name="header"></slot>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-container fluid>
        <v-data-table :items="items" :headers="headers" item-key="id">
          <template #[`item.code`]="{ item }">
            <a :href="$route('invoices.update', item.id)" target="_blank">
              <strong>{{ item.code }}</strong>
            </a>
          </template>
          <template #[`item.student`]="{ item }">
            {{ item.student.name }}
          </template>
          <template #[`item.due_date`]="{ item }">
            {{ formatDate(item.due_date, 'DD MMM YYYY') }}
            <v-chip small class="mx-1" color="warning">
              {{ timeFromNow(item.due_date) }}
            </v-chip>
          </template>
          <template #[`item.amount`]="{ item }">
            {{ formatNumber(item.total_billed_amount) }}
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip
              :color="invoiceStatusProps(item.status, 'color')"
              small
              dark
            >
              <strong>
                {{ invoiceStatusProps(item.status, 'text') }}
              </strong>
            </v-chip>
          </template>
        </v-data-table>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: 'Invoices',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: 'Invoice No.', value: 'code', sortable: false },
        { text: 'Student', value: 'student', sortable: false },
        { text: 'Due Date', value: 'due_date' },
        { text: 'Amount', value: 'amount' },
        { text: 'Status', value: 'status', sortable: false },
      ],
    }
  },
}
</script>
